import axios from 'axios';
import {GhtkAuth} from 'gmjs'
import oidc from "@/oidc";
import qs from "querystring";

const ghtkAuth = new GhtkAuth(oidc)

function createNewAxios(contextPath){
  const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL + contextPath,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
  })
  instance.defaults.headers.post['Content-Type'] = 'application/json';

  // Add a request interceptor
  instance.interceptors.request.use(function (config) {
    NProgress.start();
    // Get access token
    ghtkAuth.tokenManager.get('accessToken').then(tokenInfo => {
      const accessToken = tokenInfo ? tokenInfo.accessToken : '';
      config.headers.Authorization = `Bearer ${accessToken}`;
    });
    return config;
  });

  instance.interceptors.response.use(
      (response) => {
        NProgress.done();
        return response;
      },
      async (error) => {
        // whatever you want to do with the error
        // console.log('onRejected', error.response);
        NProgress.done();
        throw error;
      }
  );

  return instance;
}

export default {
  install(Vue) {
    Vue.prototype.$http = createNewAxios('');
    Vue.prototype.$cmsService = createNewAxios('cms');
    Vue.prototype.$adminService = createNewAxios('admin-service');
    Vue.prototype.$packageService = createNewAxios('package-service');
    Vue.prototype.$billService = createNewAxios('bill-service');
    Vue.prototype.$clientService = createNewAxios('client-service');
    Vue.prototype.$reportService = createNewAxios('report-service');
    Vue.prototype.$moshopService = createNewAxios('moshop');
  }
}